import React from "react";
import { Link } from "react-router-dom";
import { linkResolver } from "../../prismic-config";
export function PrismicNavItem(props) {
  var label = props.label,
      link = props.link;
  return React.createElement(Link, {
    to: linkResolver(link),
    className: "main-menu__nav-link"
  }, label);
}